module.exports = __webpack_public_path__ + "../resources/img/ic_zoomout_light.8fdbfa94.svg";